import { BasePagination, PaginableRequest } from 'api/common-schemas';
import {
  AccessProductGridType,
  BaseResponseMobilityAPI,
  DeviceGroupType,
  DeviceType,
  MobilityProduct,
  MobilityProductTypes,
  ProductType,
  QuestionnaireType,
  QuestionsType,
  TagType,
  VariantsType,
} from './accessExpress.types';
import Ipad from 'assets/images/Ipad.svg';
import sortBy from 'lodash/sortBy';

import {
  BuildOutline,
  ReceiptOutline,
  SpeedometerOutline,
  TimeOutline,
  WarningOutline,
  WifiOutline,
} from 'react-ionicons';
import { apiClient } from 'api/apiClient';
import {
  ProductLocationType,
  ProductOfferingType,
} from 'screens/SelectServices/schemas';
import { OrderResponse } from 'api/accessexpressv3/schemas/OrdersSchemas';
import { formatTerm } from 'screens/SelectServices/utils';
import { getIpTypeLabel } from 'screens/OpenQuote/utils';
import LocationIcon from './BaseComponents/LocationIcon';
import { ICartItem } from './CartProvider';
import {
  CompanyPreferencesResponse,
  ConfigRequirements,
} from './BaseComponents/Cart/locationFlow/access/ConfigRequirementsModal/schema';

export const questionnairesStepOne = [
  {
    type: 'access_services',
    title: 'Access services',
    body: 'Broadband, DIA, GRID',
    tags: ['Access'],
    disabled: true,
  },
  {
    type: 'mobility_services',
    title: 'Mobility services',
    body: 'Wireless routers, smart phones, tablets',
    tags: ['Mobility'],
    disabled: false,
  },
  {
    type: 'voice_services',
    title: 'Voice services',
    body: 'EPOTS, Hosted PBX, POTS',
    tags: ['Voice'],
    disabled: true,
  },
  {
    type: 'not_sure',
    title: 'I’m not sure',
    body: 'Not sure? Let us show you the way',
    tags: [],
    disabled: true,
  },
];

export const questionnairesStepTwo: QuestionnaireType[] = [
  {
    type: 'network',
    title: 'Network',
    body: 'Modems, wireless IoT',
    disabled: true,
  },
  {
    type: 'cellular',
    title: 'Cellular',
    body: 'SIMs, smart phones, tablets, hotspots, and more ',
    disabled: false,
  },
  {
    type: 'accessories',
    title: 'Accessories',
    body: 'Adapters, cases, screen protectors, antennas, batteries, and more',
    disabled: true,
  },
  {
    type: 'sims',
    title: 'SIMs',
    body: 'SIM cards for voice and data connectivity',
    disabled: true,
  },
];

export const getQuestions = async (
  services: string[],
): Promise<QuestionsType> => {
  return new Promise((resolve) => {
    console.log(services);
    resolve({
      title: 'What type of device are you looking for?',
      questions: questionnairesStepTwo,
    });
  });
};

const getSubgroupByType = (type?: string): string => {
  if (!type) return 'DEVICE';
  return (
    Object.keys(DeviceGroupType).find((group) =>
      DeviceGroupType[group as keyof typeof DeviceGroupType].includes(
        decodeURIComponent(type) as DeviceType,
      ),
    ) ?? 'DEVICE'
  );
};

export const getMobilityProducts = async (args?: {
  type: string;
}): Promise<BaseResponseMobilityAPI<ProductType[]>> => {
  const subgroup = getSubgroupByType(args?.type);

  const response = await apiClient.get<
    BaseResponseMobilityAPI<MobilityProduct[]>
  >(
    `/api/v1/marketplace/products/all?subgroup=${subgroup}${
      args?.type ? `&type=${args.type}` : ''
    }`,
  );

  return {
    ...response.data,
    data: response.data.data.map((product) => ({
      id: product.graniteId,
      title: product.graniteId,
      img: product.images[0]?.url ?? null,
      manufacturer: product.graniteId.trim().split(/\s+/)[0],
      stock: product.productQty,
      content: product.description,
      createdDate: product.createdDate,
      productDescType: product.productDesc,
    })),
  };
};

export const getProduct = async (args: {
  id: string;
}): Promise<ProductType> => {
  const { id } = args;

  const response = await apiClient.get<
    BaseResponseMobilityAPI<MobilityProduct>
  >(`/api/v1/marketplace/products/detail?alias=${encodeURIComponent(id)}`);
  const { mrc, nrc } = findLowestPricesForMobilityProduct(
    response.data.data.variants,
  );
  return {
    id: response.data.data.graniteId,
    title: response.data.data.graniteId,
    img: response.data.data.images[0]?.url ?? null,
    manufacturer: response.data.data.graniteId.trim().split(/\s+/)[0],
    stock: response.data.data.productQty,
    content: response.data.data.description,
    createdDate: response.data.data.createdDate,
    varients: response.data.data.variants,
    productId: response.data.data.productId,
    productDescType: response.data.data.productDesc,
    mrc: mrc ?? undefined,
    nrc: nrc ?? undefined,
  };
};

export const reviewOrderDummyData = {
  site: '12419 Shelbyville Rd, Middletown, KY, 40243',
  productType: 'Mobility',
  products: [
    {
      id: 1,
      manufacturer: 'Apple',
      title: `Apple iPad Mini 128GB Purple (7th Gen)`,
      from_price: 649,
      monthly_price: 41.58,
      months: '3',
      img: Ipad,
    },
    {
      id: 2,
      manufacturer: 'Apple',
      title: `iPad Mini`,
      from_price: 649.0,
      monthly_price: 41.58,
      months: '3',
      img: Ipad,
    },
    {
      id: 3,
      manufacturer: 'Apple',
      title: `iPad Mini`,
      from_price: 649.0,
      monthly_price: 41.58,
      months: '3',
      img: Ipad,
    },
    {
      id: 4,
      manufacturer: 'Apple',
      title: `iPad Mini`,
      from_price: 649.0,
      monthly_price: 41.58,
      months: '3',
      img: Ipad,
    },
    {
      id: 5,
      manufacturer: 'Apple',
      title: `iPad Mini`,
      from_price: 649,
      monthly_price: 41.58,
      months: '3',
      img: Ipad,
    },
    {
      id: 6,
      manufacturer: 'Apple',
      title: `iPad Mini`,
      from_price: 649.0,
      monthly_price: 41.58,
      months: '3',
      img: Ipad,
    },
  ],
  locations: [
    '123 Main Street, Bridgewater, MA 02324',
    '105 Jerry Dove Drive, Florence, SC 29501',
    '184 Griffin Street, Gilbert, AZ 85233',
    '1341 Poplar Street, Chicago, IL 60606',
    '612 Shadowmar Drive, New Orleans, LA 70115',
  ],
  services: ['Broadband', 'DIA', 'Mobility'],
  nrc: [
    {
      name: 'Activation fee',
      price: 100,
    },
    {
      name: 'Equipment',
      price: 100,
    },
    {
      name: 'Shipping',
      price: 100,
    },
  ],
  rc: [
    {
      name: 'Broadband connection charge',
      price: 100,
    },
    {
      name: 'DIA connection charge',
      price: 100,
    },
    {
      name: 'Router',
      price: 100,
    },
    {
      name: 'IP block',
      price: 100,
    },
  ],
};

export const accessReviewOrderDummyData = {
  services: ['Broadband', 'DIA'],
  nrc: [
    {
      name: 'Activation fee',
      price: 100,
    },
    {
      name: 'Equipment',
      price: 100,
    },
    {
      name: 'Shipping',
      price: 100,
    },
  ],
  rc: [
    {
      name: 'Broadband connection charge',
      price: 100,
    },
    {
      name: 'DIA connection charge',
      price: 100,
    },
    {
      name: 'Router',
      price: 100,
    },
    {
      name: 'IP block',
      price: 100,
    },
  ],
};

export const getOfferDetails = (offering: ProductOfferingType, tag: string) => {
  const id = (offering.formal_broadband_product?.id ||
    offering.formal_dia_product?.id) as string;

  return {
    id: id,
    tag: tag as TagType,
    price:
      offering.formal_broadband_product?.formal_broadband_pricing?.total_mrc ??
      0,
    construction_likely: offering.construction_likely,
    carrier: offering.provider,
    details: [
      {
        icon: SpeedometerOutline,
        text: `${offering.formal_broadband_product?.bandwidth_download}/${offering.formal_broadband_product?.bandwidth_upload}`,
        id: 'speed',
      },
      {
        icon: ReceiptOutline,
        text: `${formatTerm(offering.term)}`,
        id: 'term',
      },

      { icon: TimeOutline, text: '28 day install avg' },
      offering.construction_likely
        ? {
            id: 'construction_likely',
            icon: WarningOutline,
            text: CONSTRUCTION_LABEL,
          }
        : { icon: BuildOutline, text: '$0 est. construction' },

      ...(offering.formal_broadband_product
        ? [
            {
              icon: LocationIcon,
              id: 'ip_type',
              text: getIpTypeLabel(offering.formal_broadband_product.ip_type),
            },
          ]
        : []),
      ...(offering.formal_dia_product?.on_net
        ? [
            {
              icon: WifiOutline,
              id: 'on_net',
              text: `${
                offering.formal_dia_product?.on_net ? 'On' : 'Off'
              }-net connectivity`,
            },
          ]
        : []),
    ],
  };
};

export const getSortedOfferings = (currentLocation?: ProductLocationType) => {
  if (!currentLocation)
    return {
      bestOffer: undefined,
      premiumChoice: undefined,
      lowestPrice: undefined,
      allOtherOptions: [],
    };

  const sortedOfferings = sortBy(
    currentLocation?.formal_products_offerings || [],
    [(item) => (item.term === '3 YR' ? 0 : 1), (item) => -item.priority || 0],
  );

  return {
    bestOffer: sortedOfferings[0]
      ? getOfferDetails(sortedOfferings[0], 'Best offer')
      : undefined,
    premiumChoice: sortedOfferings[1]
      ? getOfferDetails(sortedOfferings[1], 'Premium choice')
      : undefined,
    lowestPrice: sortedOfferings[2]
      ? getOfferDetails(sortedOfferings[2], 'Lowest price')
      : undefined,
    allOtherOptions: sortedOfferings.slice(3),
    sortedOfferings,
  };
};

export const broadbandMetadata = {
  id: '1',
  type: 'broadband',
  title: 'Broadband',
  content:
    'Broadband services provide high-speed internet access, enabling connectivity to the internet for activities like browsing, streaming, downloading, and more. Order fiber or cable to deliver fast and reliable internet connectivity to your business.',
};

export const getAccessProductsGrid = async (
  args: PaginableRequest & { search?: string; sort_order?: 'asc' | 'desc' },
): Promise<BasePagination<ProductType>> => {
  const { page = 1, page_size = 12, search, sort_order } = args;

  const response = await apiClient.get<{
    data: AccessProductGridType[];
    page: number;
    page_size: number;
    total: number;
  }>(
    `/api/v1/access?page=${page}&page_size=${page_size}${
      search ? `&search=${search}` : ''
    }${sort_order ? `&sort_field=name&sort_order=${sort_order}` : ''}`,
  );

  const res = {
    data: response.data.data.map((product) => ({
      id: `${product.id}`,
      title: product.name,
      fullPriceInfo: product.description,
      img: product.image_url,
      category: product.category,
    })),
    metadata: {
      page: response.data.page,
      page_size: response.data.page_size,
      total_items: response.data.total,
      total_pages: Math.ceil(response.data.total / response.data.page_size),
    },
  };
  return res;
};

export const getMobilityProductTypes = async (): Promise<
  BaseResponseMobilityAPI<MobilityProductTypes>
> => {
  const response = await apiClient.get('/api/v1/marketplace/products/types');
  return response.data;
};

export const formatMobilityPrice = (price?: number) =>
  price !== undefined ? price.toFixed(2) : '0.00';

const findLowestPricesForMobilityProduct = (variants: VariantsType[]) => {
  return variants.reduce(
    (acc, variant) => {
      variant.children.forEach((child) => {
        if (child.productGroupDesc === 'PURCHASED') {
          acc.nrc =
            acc.nrc !== null
              ? Math.min(acc.nrc, child.originalPrice)
              : child.originalPrice;
        } else if (child.productGroupDesc === 'FINANCED') {
          acc.mrc =
            acc.mrc !== null
              ? Math.min(acc.mrc, child.originalPrice)
              : child.originalPrice;
        }
      });
      return acc;
    },
    { nrc: null as number | null, mrc: null as number | null },
  );
};

export const checkoutDummyAddresses = [
  {
    account_name: '04683713',
    address_line_1: '12419 Shelbyville Rd',
    address_line_2: '12',
    city: 'Middletown',
    id: '73585',
    macnum: '04683713',
    name: '04683713 - 40132',
    parent_macnum: '03479292',
    parent_name: 'Valvoline',
    site_name: '40132',
    state: 'KY',
    zip: '40243',
    cw_site_id: '001233689',
  },
  {
    account_name: '04683717',
    address_line_1: '1861 Gardner Lane NW',
    address_line_2: null,
    city: 'Corydon',
    id: '73588',
    macnum: '04683717',
    name: '04683717 - 40136',
    parent_macnum: '03479292',
    parent_name: 'Valvoline',
    site_name: '40136',
    state: 'IN',
    zip: '47112',
    cw_site_id: '001233688',
  },
  {
    account_name: '04683730',
    address_line_1: '2976 S Church Street',
    address_line_2: null,
    city: 'Murfreesboro',
    id: '73603',
    macnum: '04683730',
    name: '04683730 - 40157',
    parent_macnum: '03479292',
    parent_name: 'Valvoline',
    site_name: '40157',
    state: 'TN',
    zip: '37127',
    cw_site_id: '001233687',
  },
  {
    account_name: '04683731',
    address_line_1: '7065 E US Hwy 36',
    address_line_2: null,
    city: 'Avon',
    id: '73604',
    macnum: '04683731',
    name: '04683731 - 40158',
    parent_macnum: '03479292',
    parent_name: 'Valvoline',
    site_name: '40158',
    state: 'IN',
    zip: '46123',
    cw_site_id: '001233686',
  },
  {
    account_name: '04683752',
    address_line_1: '10229 Watson Road',
    address_line_2: null,
    city: 'Sappington',
    id: '73624',
    macnum: '04683752',
    name: '04683752 - 50009',
    parent_macnum: '03479292',
    parent_name: 'Valvoline',
    site_name: '50009',
    state: 'MO',
    zip: '63127',
    cw_site_id: null,
  },
];

export const checkoutOrderItems = [
  {
    type: 'Access',
    subtype: 'Broadband',
    pim_price_id: 'PIM1234',
    quantity: 2,
    location_id: 'loc-001',
    item_details: {
      detail1: 'value1',
      detail2: 'value2',
    },
    price: 49.99,
  },
  {
    type: 'Mobility',
    subtype: 'Phone',
    pim_price_id: 'PIM5678',
    quantity: 1,
    location_id: 'loc-001',
    item_details: {
      model: 'XYZ',
      color: 'black',
    },
    price: 99.99,
  },
  {
    type: 'Sims',
    subtype: 'Standard',
    pim_price_id: 'PIM9012',
    quantity: 1,
    location_id: 'loc-001',
    item_details: {
      carrier: 'ABC',
    },
    price: 19.99,
  },
];

export const getDistinctAccessOrderedServices = (data?: OrderResponse) => {
  if (!data) return '';
  const orderedProducts = new Set();

  data.locations?.forEach((location) => {
    location.order_items.forEach((item) => {
      if (['Broadband', 'DIA'].includes(item.subtype))
        orderedProducts.add(item.subtype);
    });
  });

  return Array.from(orderedProducts).join(', ');
};

export const CONSTRUCTION_LABEL = 'Potential construction';

export const getMNSPrice = (productOffering: ProductOfferingType) => {
  const productPricingPath =
    productOffering?.product_type?.toLowerCase() === 'broadband'
      ? productOffering.formal_broadband_product?.formal_broadband_pricing
      : productOffering?.product_type?.toLowerCase() === 'dia'
        ? productOffering.formal_dia_product?.formal_dia_pricing
        : null;

  if (!productPricingPath) return 0;

  return (
    (productOffering?.mns_enhanced
      ? productPricingPath?.mns_enhanced
      : productOffering.mns_essential
        ? productPricingPath?.mns_essentials
        : 0) ?? 0
  );
};

export const getPriceWithMNS = (item: ICartItem) => {
  const mnsPrice = getMNSPrice(item.item_details as ProductOfferingType);

  return item.price + mnsPrice;
};

export const downloadOptions = [
  { label: '10 Mbps', value: '10' },
  { label: '20 Mbps', value: '20' },
  { label: '50 Mbps', value: '50' },
  { label: '100 Mbps', value: '100' },
  { label: '200 Mbps', value: '200' },
  { label: '300 Mbps', value: '300' },
  { label: '400 Mbps', value: '400' },
  { label: '500 Mbps', value: '500' },
  { label: '600 Mbps', value: '600' },
  { label: '700 Mbps', value: '700' },
  { label: '800 Mbps', value: '800' },
  { label: '900 Mbps', value: '900' },
  { label: '1000 Mbps', value: '1000' },
];

export const termOptions = [
  { label: '1 year', value: '1' },
  { label: '2 years', value: '2' },
  { label: '3 years', value: '3' },
];

export const ipBlockOptions = [
  { label: '/29', value: '/29' },
  { label: '/30', value: '/30' },
];

export const ipTypeOptions = [
  { label: 'Static', value: 'static' },
  { label: 'Dynamic', value: 'dynamic' },
];

export const preferredCarrierOptions = [
  { label: 'cincinnati bell', value: 'altafiber' },
  { label: 'armstrong', value: 'armstrong granite upload' },
];

export const carrierOptions = [
  { label: 'AT&T', value: 'AT&T' },
  { label: 'Alaska Communications', value: 'Alaska Communications' },
  { label: 'Altice/Optimum', value: 'Altice/Optimum' },
  { label: 'Armstrong', value: 'Armstrong' },
  { label: 'Astound', value: 'Astound' },
  { label: 'Atlantic Broadband', value: 'Atlantic Broadband' },
  { label: 'Brightspeed', value: 'Brightspeed' },
  { label: 'Cable One', value: 'Cable One' },
  { label: 'CenturyLink/Lumen', value: 'CenturyLink/Lumen' },
  { label: 'Cincinnati Bell/AltaFiber', value: 'Cincinnati Bell/AltaFiber' },
  { label: 'Comcast', value: 'Comcast' },
  { label: 'Cox', value: 'Cox' },
  { label: 'Fairpoint/Consolidated', value: 'Fairpoint/Consolidated' },
  { label: 'Fidelity', value: 'Fidelity' },
  { label: 'Frontier', value: 'Frontier' },
  { label: 'GTT', value: 'GTT' },
  { label: 'Granite Rural Broadband', value: 'Granite Rural Broadband' },
  {
    label: 'Great Plains Communications',
    value: 'Great Plains Communications',
  },
  { label: 'Hargray', value: 'Hargray' },
  { label: 'Hunter', value: 'Hunter' },
  { label: 'Liberty PR', value: 'Liberty PR' },
  { label: 'Mediacom', value: 'Mediacom' },
  { label: 'MetroNet', value: 'MetroNet' },
  { label: 'Midco', value: 'Midco' },
  { label: 'Nex-Tech', value: 'Nex-Tech' },
  { label: 'PenTeleData', value: 'PenTeleData' },
  { label: 'Ritter', value: 'Ritter' },
  { label: 'Shentel/GLoFiber', value: 'Shentel/GLoFiber' },
  { label: 'Spectrum', value: 'Spectrum' },
  { label: 'Verizon', value: 'Verizon' },
  { label: 'Vyve', value: 'Vyve' },
  { label: 'WOW!', value: 'WOW!' },
  { label: 'Windstream', value: 'Windstream' },
  { label: 'Ziply Fiber', value: 'Ziply Fiber' },
];

export const buildConfigRequirementsModalDefaults = (
  companyPreferences?: Partial<CompanyPreferencesResponse>,
): Partial<ConfigRequirements> | undefined => {
  if (!companyPreferences) return undefined;

  return {
    term: companyPreferences.term
      ? {
          value: companyPreferences.term,
          label: termOptions.find(
            (item) => item.value === companyPreferences.term,
          )?.label as string,
        }
      : termOptions[2],
    download: companyPreferences.max_download
      ? {
          value: companyPreferences.max_download,
          label: downloadOptions.find(
            (item) => item.value === companyPreferences.max_download,
          )?.label as string,
        }
      : undefined,
    preferred_carriers: companyPreferences.preferred_carriers?.map((c) => ({
      value: c,
      label: c,
    })),
    exclude_carriers: companyPreferences.exclude_carriers?.map((c) => ({
      value: c,
      label: c,
    })),
    ip_type: companyPreferences.ip_type
      ? {
          value: companyPreferences.ip_type,
          label: ipTypeOptions.find(
            (opt) => opt.value === companyPreferences.ip_type,
          )?.label as string,
        }
      : undefined,
    ip_block: companyPreferences.ip_block
      ? {
          value: companyPreferences.ip_block,
          label: ipBlockOptions.find(
            (opt) => opt.value === companyPreferences.ip_block,
          )?.label as string,
        }
      : undefined,
    save_default: false,
  };
};
